export default __webpack_public_path__ + "static/banner_faq-54487b5e9c1c2d46f965a3b7e3a586f2.png";